export const productionPlanRoutes = {
  listing: '/productionplan/plan',
  add: '/productionplan/plan/add'
};
